<div class="state-subsidy-results">
  <h6 class="t-bold">{{ config.title }}</h6>

  <div class="underline"></div>

  @for (section of stateSubsidyResultSections; track section) {
    <div class="section">
      <p class="t-data t-bold">{{ section?.title }}</p>
      @if (section.type === 'text') {
        <div class="section--text">
          <p class="t-data" [innerHTML]="section?.text"></p>
        </div>
      }
    </div>
  }
</div>
